import {EventEmitter, Injectable} from '@angular/core';
import {OAuthService} from "angular-oauth2-oidc";
import {HttpService} from "./http.service";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {I18nProvider} from "./i18n.service";
import { Router } from '@angular/router'; // Import Router for navigation

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  loginInEvent = new EventEmitter();

  constructor(private oauthService: OAuthService, private http: HttpService, private i8Provider: I18nProvider, private router: Router) { // Inject Router
  }

  private hasReloaded = false;

  handleLogin() {
    if (this.hasReloaded) { return; } // Exit if already reloaded

    this.i8Provider.load().then(r => {
      this.i8Provider.langUpdated.emit(this.i8Provider.language);
      this.loginInEvent.emit(true);
      this.router.navigate(['/home']); // Redirect to home page or desired route
      this.hasReloaded = true; // Set the flag to true
      location.reload(); // Refresh the page
    });
  }


  handleLogout() {
    this.oauthService.revokeTokenAndLogout();
    this.loginInEvent.emit(false);
    sessionStorage.clear();
  }

  getEmitter() {
    return this.loginInEvent;
  }

  public loginUser(): Observable<any> {
    return this.http.loginUser(sessionStorage.getItem("access_token"))
      .pipe(map((res: any) => res.token))
      .pipe(map(token => this.setLoginRoles(token)));
  }

  public loginUserTest(): Observable<any> {
    return this.http.loginUserTest()
      .pipe(map((res: any) => this.setLoginRoles(res.token)));
  }

  private setLoginRoles(token: string) {
    sessionStorage.setItem('DWP_TOKEN', token);
    const d = JSON.parse(atob(sessionStorage.getItem('DWP_TOKEN').split('.')[1]));
    sessionStorage.setItem('user', d.name);
    sessionStorage.setItem('dealer', d.dealer);
    sessionStorage.setItem('company', d.company);
    sessionStorage.setItem('market', d.market);
    if (d.role === 'DWCP_ADMIN' || d.role === 'DWP_ADMIN') {
      sessionStorage.setItem('role', 'DWP_ADMIN');
    } else if (d.role === 'DWCP_USER' || d.role === 'DWP_USER') {
      sessionStorage.setItem('role', 'DWP_USER');
    } else if (d.role === 'DWP_READONLY' || d.role === 'DWCP_READONLY') {
      sessionStorage.setItem('role', 'DWCP_READONLY');
    } else {
      sessionStorage.setItem('role', d.role);
    }

    sessionStorage.setItem('oidc-token', sessionStorage.getItem("id_token"));
    localStorage.setItem('selectedLanguage', d.lang.toLowerCase());
  }
}
